<template>
  <HeaderDialog
    :show="show"
    id="new_product_price_editing"
    :title="$t('priceChangeWarning.priceAdjustment')"
    :subtitle="$t('priceChangeWarning.subtitle')"
    width="800"
    :showCloseBtn="false"
    :actionText="$t('priceChangeWarning.iUnderstood')"
    @action="priceChangeNoticed"
  >
    <template v-slot:body>
      <v-row class="mx-3 mb-2" no-gutters>
        <p class="mt-4">
          <span v-html="$t('priceChangeWarning.warning')"></span>
          <a
            href="https://conectasuite.com/precos/"
            target="_blank"
            class="text-body-1 text-decoration-none"
          >
            <span class="font-weight-bold blue--text"> Conecta Suite.</span>
          </a>
        </p>
        <p>{{ $t("priceChangeWarning.noActionNeeded") }}</p>
        <p>
          {{ $t("priceChangeWarning.willingToHelp") }}
          <a
            class="text-body-1 font-weight-bold text-decoration-none"
            href="mailto:sucesso@conectasuite.com"
          >
            <span class="text-body-1 font-weight-bold blue--text"
              >sucesso@conectasuite.com</span
            >
          </a>
        </p>
        <p>{{ $t("priceChangeWarning.thanks4BeeingClient") }}</p>
      </v-row>
    </template>
  </HeaderDialog>
</template>

<script>
import { today } from "@/helpers/services/utils";
import {
  SUITE_DEV_PROJECT_NAME,
  SUITE_PROD_PROJECT_NAME,
} from "@/helpers/variables/backendConstants";
import { domainsToSeePriceChangeWarning } from "@/helpers/variables/domainsSeePriceChange";
import { child, get, getDatabase, ref, set } from "firebase/database";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "PriceChangeNotice",
  data: () => ({
    show: false,
    domainsToSeePriceChangeWarning,
  }),
  computed: {
    ...mapGetters(["company", "currentUser", "token", "isSimulation"]),
    mainDomain() {
      return this.company?.main_domain || "";
    },
  },
  mounted() {
    if (
      !this.isSimulation &&
      this.domainsToSeePriceChangeWarning.includes(this.mainDomain)
    ) {
      this.checkIfUserAlreadySeenThePriceChange();
    }
  },
  methods: {
    setUserNoticedPriceChange() {
      const database = getDatabase();

      set(ref(database, `noticed_price_change/${this.currentUser.key}`), {
        email: this.currentUser.email,
        date: today.format("DD/MM/YYYY HH:mm:ss"),
        id_google: this.currentUser.id_google,
      });
    },

    saveNoticedPriceChange() {
      const url = `${process.env.VUE_APP_BIG_QUERY_API}/save-noticed-price-changes`;
      const project_name =
        process.env.NODE_ENV !== "production"
          ? SUITE_DEV_PROJECT_NAME
          : SUITE_PROD_PROJECT_NAME;

      const { name, id_google, email } = this.currentUser;

      const payload = {
        project_name,
        app: "Conecta Suite",
        name,
        id_google,
        email,
        main_domain: this.mainDomain,
      };

      this.$axios
        .post(url, payload)
        .then(() => {})
        .catch((err) => {
          console.error("saveNoticedPriceChange()", err);
        })
        .finally(() => {});
    },

    priceChangeNoticed() {
      this.setUserNoticedPriceChange();
      this.show = false;

      this.saveNoticedPriceChange();
    },

    checkIfUserAlreadySeenThePriceChange() {
      const cutoffDate = moment(`30/05/2026`, "DD/MM/YYYY");
      if (today.isSameOrBefore(cutoffDate)) return;

      const dbRef = ref(getDatabase());
      get(child(dbRef, `noticed_price_change/${this.currentUser.key}`))
        .then((snapshot) => {
          if (!snapshot.exists()) {
            this.show = true;
            return;
          }

          const data = snapshot.val();
          const savedDate = moment(data.date, "DD/MM/YYYY");

          if (savedDate.isBefore(cutoffDate)) {
            this.show = true;
          }
        })
        .catch((error) => {
          console.error("checkIfUserAlreadySeenThePriceChange()", error);
        });
    },
  },
};
</script>
